import clsx from "clsx";
import { useEffect, useImperativeHandle, useState } from "react";
import { useAnimate, motion } from "framer-motion";
import { useGameSounds } from "@educaplay/core";
import { COMPLETAR_SOUNDS } from "../../utils/constants";
import classes from './Dropdown.module.scss';
import { CorrectIcon } from "../Icons";
import { useSelector } from "react-redux";
import DropdownField from "./DropdownField";

export const Dropdown = (props) => {
    const { blankId, gameState, setGameState, ref } = props;
    const gameSounds = useGameSounds();

    const [wordRef, animateWord] = useAnimate();    
    const [animationStatus, setAnimationStatus] = useState(null);
    const options = useSelector(state => state.game.questions[state.game.currentIndex].dropdownOptions);

    useImperativeHandle(ref, () => ({
        success: async () => {
            wordRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
            gameSounds.play(COMPLETAR_SOUNDS.CORRECT);
            setAnimationStatus('success');
            await animateWord(wordRef.current, { y: [-20, 0] }, {  duration: .3 });
        },
        fail: async () => {
            wordRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
            gameSounds.play(COMPLETAR_SOUNDS.WRONG);
            setAnimationStatus('fail');
            await animateWord(wordRef.current, { y: [-20, 0] }, {  duration: .3 });
        },
        empty: async () => {
            wordRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
            setAnimationStatus(null);
            await animateWord(wordRef.current, { x: [-20, 18, -10, 4, 0] }, { duration: .3 });
        }
    }));
        
    useEffect(() => {
        setAnimationStatus(null);
    }, [gameState]);

    const blank = gameState.idBlanks?.find(blank => blank.id === blankId) ?? null;
    if (!blank) return

    // const isFilled = blank.fill !== '' || animationStatus === 'success' || animationStatus === 'fail';
    const isCorrect = blank.isCorrect || animationStatus === 'success';
    const isWrong = (blank.isCorrect !== null && !blank.isCorrect) || animationStatus === 'fail';

    const handleChange = (wordId) => {
        const newGameState = {
            ...gameState,
            idBlanks: gameState.idBlanks.map(blank => {
                if (blank.id === blankId) {
                    return {
                        ...blank,
                        fill: wordId
                    }
                }
                return blank;
            })
        }
        setGameState(newGameState);
    }

    const handleHover = () => {
        if (blank.isCorrect) return;
        gameSounds.play(COMPLETAR_SOUNDS.HOVER);
    }

    const currentOptions = options[blankId] ?? [];

    const fill = gameState.idBlanks?.find(blank => blank.id === blankId)?.fill ?? null;
    
    return (
        <motion.span
            ref={wordRef}
            onMouseEnter={handleHover}
            className={ classes.selectWrapper }
        >
            {isCorrect ?
                <div
                    className={classes.correct}
                    key={blankId}
                    data-animation-status={animationStatus}
                >   
                    <CorrectIcon />
                    <span>{fill}</span>
                </div>
            :
                <DropdownField
                    options={currentOptions}
                    onChange={handleChange}
                    value={fill}
                    className={
                        clsx(
                            classes.select,
                            // isFilled && classes['select--filled'],
                            isCorrect && classes['select--correct'],
                            isWrong && classes['select--wrong'],
                        )}
                />
                    }
        </motion.span>
    );
}